// Single source of truth for how translated audio is played back for a call.
export const AUDIO_MODES = {
  NONE: "none",
  REALTIME: "realtime",
  LEGACY_SPEAKER: "legacy_speaker",
  AGENT_TRACK: "agent_track",
};

export const getCallAudioMode = ({ selectedCall, useRealtimeApi } = {}) => {
  if (!selectedCall) {
    return AUDIO_MODES.NONE;
  }

  if (!selectedCall.conference_id) {
    return AUDIO_MODES.AGENT_TRACK;
  }

  return useRealtimeApi ? AUDIO_MODES.REALTIME : AUDIO_MODES.LEGACY_SPEAKER;
};

export const shouldUseLiveKitAgentAudio = (opts) =>
  getCallAudioMode(opts) === AUDIO_MODES.AGENT_TRACK;

export const shouldUseLegacyTranslatedSpeaker = (opts) =>
  getCallAudioMode(opts) === AUDIO_MODES.LEGACY_SPEAKER;
